import "./style.scss"

import 'jquery-form-validator';
import 'master';
import datepickerFactory from 'jquery-datepicker';

datepickerFactory($);

$(function() {

  $('#event-datepicker').datepicker();
  

  $.validate({
    form: '#form-forget-password',
    validateOnBlur : false,
    errorMessagePosition : 'inline',
    scrollToTopOnError : false,
    inlineErrorMessageCallback: function($input, errorMessage, config) {
      if ($input.hasClass('error')) {
        $('.comp-error-list .inner').append('<p data-error-id='+$input.attr('id')+'>'+errorMessage+'</p>');
      }else{
        $('.comp-error-list p[data-error-id='+$input.attr('id')+']').remove();
      }
      
      // for MTcaptcha
      if (!document.querySelector('.mtcaptchaER')) {        
        if (mtcaptcha.getVerifiedToken() == null || mtcaptcha.getVerifiedToken() == "") {
          $('.comp-error-list .inner').append('<p class="mtcaptchaER" data-error-id=mtcaptcha>Please complete the captcha verification.</p>');
          
        }
      }
      
      
    },
    onError : function($form) {
      $('.comp-error-list').show();
      toNameAnchor('.comp-error-list');
      window.scrollTo(0, 0);
     
    },
    onSuccess : function($form) {
      // generateEmail();
      // autoEmailfunction();
      var _formValidatedStatus = false;
      var _newPwd = $('#edit-submitted-newpsd').val(),
          _confirmPwd = $('#edit-submitted-newpsdconfirm').val();

      //check new password regEX
      var inputNewPsd = _newPwd;
      var regEXFormat1 = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      var regEXFormat2 = /[A-Z]/;
      var regEXFormat3 = /[a-z]/;
      var regEXFormat4 = /[0-9]/;
      // console.log("test 1:", /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(input))
      // console.log("test 2:", /[A-Z]/.test(input))
      // console.log("test 5:", input.length)
      if (regEXFormat1.test(inputNewPsd) && regEXFormat2.test(inputNewPsd) && regEXFormat3.test(inputNewPsd) && regEXFormat4.test(inputNewPsd) && (inputNewPsd.length >= 8)) {
          //console.log("MATCH");
          // _formValidatedStatus = true;
          if (_newPwd == _confirmPwd) {
            //console.log("same psd")
            _formValidatedStatus = true;
            $('.comp-error-list .inner').empty();
            $('.comp-error-list').hide();
            //call the API to update here
            autoUpdatePSDfunction();
            window.scrollTo(0, 0);

          } else {
            //console.log("not same psd")
            $('.comp-error-list .inner').empty().html('<p>Your new password is not same as the confirm password.</p>');
            $('.comp-error-list').show();
            window.scrollTo(0, 0);
            $(".pg-loader").remove();
            _formValidatedStatus = false;
          }
      }
      else {
          //console.log("NO MATCH");
          $('.comp-error-list .inner').empty().html('<p>Your New Password should be at least 8 letters in length contain uppercase letters, lowercase letters and numbers contain special characters.</p>');
          $('.comp-error-list').show();
          window.scrollTo(0, 0);
          $(".pg-loader").remove();
          _formValidatedStatus = false;
      }
      
    },
    onValidate : function($form) {
      if ($('.comp-error-list p').length<=0) {
        $('.comp-error-list').hide();
        $(".pg-loader").remove();
      }
    }
  });

});


function toNameAnchor(target){
  if($(target).length>0){
    $('html, body').delay(200).animate({
            scrollTop: $(target).offset().top-$('header').outerHeight()
    }, 500);
  };
}

function generateEmail() {
  //var emailTo = 'denise_chow@hkfc.com';

  var emailTo = confirmEmail;
  var emailSubject = 'Forgot Password';
  var emailBody = "\%0AName: " + $("#edit-submitted-your-name").val() + "\%0AHKFC membership: " + $("#edit-submitted-membership-no").val() + "\%0APhone: " + $("#edit-submitted-phone-no").val() + "\%0AEmail: " + $("#edit-submitted-e-mail").val();
  location.href = "mailto:" + emailTo + "?" +
    (emailSubject ? "&subject=" + emailSubject : "") +
    (emailBody ? "&body=" + emailBody : "");
}
// var _rootEshopAPIurl = (process.env.NODE_ENV == 'production')?  '':'http://13.75.104.238';
var _rootEshopAPIurl = (process.env.NODE_ENV == 'production')?  '':'http://23.99.125.215';

function autoUpdatePSDfunction() {
  
  var _apiUrlUserInfo = _rootEshopAPIurl + '/Umbraco/api/Membership/ResetPassword';
  // console.log("mt Token:", mtcaptcha.getVerifiedToken());
  if (!document.querySelector('.mtcaptchaER')) { 
    if (mtcaptcha.getVerifiedToken() == null || mtcaptcha.getVerifiedToken() == "") {
      $('.comp-error-list .inner').empty().html('<p class="mtcaptchaER">Please complete the captcha verification.</p>');
      $('.comp-error-list').show();
      
      window.scrollTo(0, 0);
      return false;
    } else {
      var _pgLoader = '<div class="pg-loader"><div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>';
      $('.main').append(_pgLoader);
    }
  }
  var _formDataCreate = [
    {
      //"name": $("#edit-submitted-your-name").val(),
      "WebId": $("#edit-submitted-membership-no").val(),
      "Email": $("#edit-submitted-e-mail").val(),
      "Password": $("#edit-submitted-newpsdconfirm").val(),
      "mtToken": mtcaptcha.getVerifiedToken()   
    }
  ];

  // console.log("_formDataCreate:", _formDataCreate[0])

  $.ajax({
		type: 'POST',
		url: _apiUrlUserInfo,		
    data: _formDataCreate[0],
    dataType: "json",
		contentType: "application/x-www-form-urlencoded",
		success: function success(response) {
			//Load API content

      var _pgLoader = '<div class="pg-loader"><div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>';
      $('.main').append(_pgLoader);
      
			if (response.Code == "400") {        
				//document.location.href = '/';
        $('.comp-error-list .inner').empty().html('<p>' + response.Message + '</p>');
        $('.comp-error-list').show();
        window.scrollTo(0, 0);
        $(".pg-loader").remove();
			} 

			if (response.Code == "200") {
        //console.log("Success")
        // document.location.href = '/thank-you';
				document.location.href = '/reset-password-thank-you'

			}
		}
	});	

}

function autoEmailfunction() {
  
  var _apiUrlUserInfo = _rootEshopAPIurl + '/Umbraco/api/Membership/forgotpassword';

  var _formDataCreate = [
    {
      "name": $("#edit-submitted-your-name").val(),
      "memberNo": $("#edit-submitted-membership-no").val(),
      "email": $("#edit-submitted-e-mail").val(),
      "phone": $("#edit-submitted-phone-no").val()      
    }
  ];

  // console.log("_formDataCreate:", _formDataCreate[0])

  $.ajax({
		type: 'POST',
		url: _apiUrlUserInfo,		
    data: _formDataCreate[0],
    dataType: "json",
		contentType: "application/x-www-form-urlencoded",
		success: function success(response) {
			//Load API content
      
			if (response.Code == "400") {
				document.location.href = '/';
			} 

			if (response.Code == "200") {
        // document.location.href = '/thank-you';
        document.location.href = '/reset-password-thank-you'
				
			}
		}
	});	

}
